import * as React from "react";
import { Box, Typography } from "@mui/material";

interface MetricCardProps {
  label: string;
  value?: string | number | boolean | null;
  /** Overrides `value`'s text rendering with an arbitrary node (e.g. a badge) — still one backend field, just rendered richer than plain text. */
  render?: React.ReactNode;
}

/**
 * Displays exactly one backend-reported field. Renders "Not reported by
 * backend" when the value is null/undefined rather than fabricating a
 * placeholder number — this component never invents data.
 */
export function MetricCard({ label, value, render }: MetricCardProps): React.JSX.Element {
  const isMissing = value === null || value === undefined || value === "";
  const displayValue = isMissing
    ? "Not reported by backend"
    : typeof value === "boolean"
      ? value
        ? "Yes"
        : "No"
      : String(value);

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
        {label}
      </Typography>
      {render ? (
        render
      ) : (
        <Typography
          variant="body1"
          color={isMissing ? "text.disabled" : "text.primary"}
          fontStyle={isMissing ? "italic" : "normal"}
        >
          {displayValue}
        </Typography>
      )}
    </Box>
  );
}
